// Export the Footer component for use on frontend/apps/marketing/src/app/[brand]/layout.tsx
export type {FooterProps} from './FooterMui';
export {default} from './FooterMui';
